import React from "react";
import { I18n } from "../../../../i18n/i18n";
import { QualityLevel } from "../../../../model/qualityLevel/QualityLevel";

import "@styles/c-qualityLevels.scss";

interface Props {
  className: string;
  i18n: I18n;
  bandwidth: number;
  qualityLevels: QualityLevel[];
}

export const QualityLevelsComponent: React.SFC<Props> = ({ className, i18n, bandwidth, qualityLevels }) => {
  if (qualityLevels === undefined || bandwidth === undefined) {
    return <></>;
  }
  const formatBandwidth = (b: number) => (b / Math.pow(10, 6)).toFixed(3);
  return (
    <div className={`c-qualityLevels ${className}`}>
      <div className="c-qualityLevels__bandwidth">
        {i18n.bandwidth} {formatBandwidth(bandwidth)} {i18n.mbps}
      </div>
      {qualityLevels.map((quality) => (
        <div
          className={`c-qualityLevels__level ${quality.isCurrent ? "c-qualityLevels__level--current" : ""}`}
          key={quality.id}
        >
         {formatBandwidth(quality.bandwidth)} {i18n.mbps}
        </div>
      ))}
    </div>
  );
};
